import React, { lazy } from "react";
import { Navigate, useParams } from "react-router-dom";
import LazyLoading from "../../common/components/LazyLoading/LazyLoading";
import AuthorizeUser from "../../middleware/AuthorizeUser";

const PropertiesPage = lazy(() =>
	import("../../pages/properties/PropertiesPage")
);
const MyProperties = lazy(() =>
	import("../../pages/properties/my-properties/MyProperties")
);
const ListingsTab = lazy(() =>
	import("../../pages/properties/listings/ListingsTab")
);
const CommunityConsole = lazy(() =>
	import("../../pages/properties/community/CommunityConsole")
);
const ResidentPortal = lazy(() =>
	import("../../pages/properties/community/ResidentPortal")
);
const CommunityEntry = lazy(() =>
	import("../../pages/properties/community/CommunityEntry")
);

function LockerRedirect() {
	const { propertyId } = useParams();
	return (
		<Navigate
			to={`/properties/listings?for=owned&property=${encodeURIComponent(propertyId || "")}`}
			replace
		/>
	);
}

const propertiesRoutes = [
	{
		path: "",
		element: (
			<LazyLoading>
				<PropertiesPage />
			</LazyLoading>
		),
		children: [
			{
				path: "",
				element: <Navigate to='my-properties' replace />,
			},
			{
				path: "my-properties",
				element: (
					<LazyLoading>
						<MyProperties />
					</LazyLoading>
				),
			},
			{
				// A property's locker now opens inside My Properties (the
				// Properties page's first tab), so old links land there with
				// that property open.
				path: "my-properties/:propertyId",
				element: <LockerRedirect />,
			},
			// The listings hub and a single listing are the SAME component on
			// purpose. `listings/:id` used to mount a standalone <ListingDetail>,
			// which meant a listing URL threw away the list, the filters and the
			// map — so the app never navigated to one, and no listing had a URL
			// Google could index. Rendering <ListingsTab /> for both lets it read
			// the :id param and open the detail as the usual slide-in panel:
			// the browse experience is unchanged, but every listing now has a
			// real, shareable, crawlable URL, and a visitor landing on one from
			// search sees the rest of the inventory beside it.
			{
				path: "listings",
				element: (
					<LazyLoading>
						<ListingsTab />
					</LazyLoading>
				),
			},
			{
				// Matches "<slug>-<id>" and the legacy bare "<id>"; ListingsTab
				// resolves both and rewrites the URL to the canonical slug form.
				path: "listings/:id",
				element: (
					<LazyLoading>
						<ListingsTab />
					</LazyLoading>
				),
			},
			{
				path: "community",
				element: (
					<LazyLoading>
						<CommunityEntry />
					</LazyLoading>
				),
			},
			{
				path: "community/manage",
				element: (
					<LazyLoading>
						<CommunityConsole />
					</LazyLoading>
				),
			},
			{
				path: "community/resident",
				element: (
					<LazyLoading>
						<ResidentPortal />
					</LazyLoading>
				),
			},
		],
	},
];

export default propertiesRoutes;
